function formatToBRL(value) {
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}

function updateAfettoPriceBlocks(priceInCents) {
  if (priceInCents == null) return;

  // taxa de parcelas e desconto pix sao product-wide (mesmos para todas variantes).
  // pegamos do primeiro radio de opcao disponivel.
  const anyOption = document.querySelector('[data-variant-qtd-parcela]');
  const installmentCount = parseInt(anyOption?.dataset.variantQtdParcela, 10) || 1;
  const discountPercentage = parseFloat((anyOption?.dataset.variantPix || '0').replace(',', '.')) || 0;

  const priceNumber = priceInCents / 100;
  const installmentValue = priceNumber / installmentCount;
  const discountValueNumber = priceNumber * (discountPercentage / 100);
  const finalPriceNumber = priceNumber - discountValueNumber;

  const fullPrice = document.querySelector('#full-price-product');
  const parcela = document.querySelector('#parcela');
  const pixProduct = document.querySelector('#pix-produto');
  const pixDesconto = document.querySelector('#pix-desconto');

  if (fullPrice) fullPrice.textContent = formatToBRL(priceNumber);
  if (parcela) parcela.textContent = formatToBRL(installmentValue);
  if (pixProduct) pixProduct.textContent = formatToBRL(finalPriceNumber);
  if (pixDesconto) pixDesconto.textContent = `Pague com pix e economize ${formatToBRL(discountValueNumber)}`;
}

document.addEventListener('DOMContentLoaded', () => {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const variant = data?.variant;
    if (!variant) return;
    updateAfettoPriceBlocks(variant.price);
  });
});
